/* eslint-disable */
import { WebPlugin } from '@capacitor/core';

import type { DrmPlayerPlugin } from './definitions';

export class DrmPlayerWeb extends WebPlugin implements DrmPlayerPlugin {
  async play(options: { url: string, licenseUrl: string, watermarkId: string }): Promise<{ url: string, licenseUrl: string, watermarkId: string }> {
    console.log('ECHO', options);
    return options;
  }
}
